import { useEffect, useState } from 'react'
import NumpadComponent from './NumpadComponent'
import { toast } from 'react-toastify'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { encryptPin } from 'src/AESEncryptUtil'
import { Spinner } from 'react-bootstrap'

export const PinEntryVarOne = ({ pin, verifyPinWithApi, onSuccessFunc }) => {
  const [enteredPin, setEnteredPin] = useState('')
  const [verifying, setVerifying] = useState(false)

  const handleNumpadClick = (digit) => {
    if (enteredPin.length < 4) {
      // Restrict PIN length to 4 digits
      setEnteredPin((prev) => prev + digit)
    }
  }

  const handleBackspace = () => {
    setEnteredPin((prev) => prev.slice(0, -1))
  }

  const handleSubmit = async () => {
    if (verifyPinWithApi) {
      try {
        const encryptedPin = encryptPin(enteredPin)
        setVerifying(true)
        const response = await getDataWithParams('/api/secure/user/verify-quick-access-pin', {pin: encryptedPin})
        setVerifying(false)
        if (response?.status === 200) {
          if (response?.data) {
            onSuccessFunc()
          } else {
            toast.error('Wrong PIN')
          }
        } else {
          toast.error('Failed to verify PIN')
        }
      } catch (e) {
        console.error(e)
        toast.error('Failed to verify PIN')
      }
    } else {
      if (enteredPin === pin.toString()) {
        onSuccessFunc()
      } else {
        toast.error('Incorrect PIN')
      }
    }
  }

  useEffect(() => {
    if (enteredPin.length === 4) {
      handleSubmit()
    }
  }, [enteredPin])

  return (
    <div style={{ 
      padding: '20px',
      background: 'linear-gradient(135deg, #b8c6f5 0%, #dac3f0 100%)',
      borderRadius: '16px',
      minWidth: '280px',
      boxShadow: '0 8px 32px rgba(150, 150, 200, 0.3)'
    }}>
      <div style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#4a5568',
        marginBottom: '12px',
        textAlign: 'center',
        letterSpacing: '0.3px'
      }}>
        🔐 Enter Access PIN
      </div>
      
      {verifying && (
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          color: '#5a67d8',
          fontSize: '13px',
          fontWeight: '500'
        }}>
          <Spinner variant='primary' size='sm' />
          <span>Verifying...</span>
        </div>
      )}
      
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '16px'
      }}>
        <input
          type="password"
          value={enteredPin}
          readOnly
          style={{
            width: '180px',
            border: 'none',
            borderBottom: '2px solid rgba(90, 103, 216, 0.3)',
            padding: '10px 6px',
            fontSize: '24px',
            textAlign: 'center',
            letterSpacing: '12px',
            fontFamily: 'monospace',
            fontWeight: '700',
            color: '#5a67d8',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '8px 8px 0 0',
            outline: 'none',
            transition: 'all 0.3s ease',
            boxShadow: enteredPin.length > 0 ? '0 2px 8px rgba(90, 103, 216, 0.2)' : 'none'
          }}
          placeholder="••••"
        />
      </div>
      
      <NumpadComponent
        clickFunc={handleNumpadClick}
        clickSound={true}
        submitVisible={true}
        submitDisabled={enteredPin.length < 4}
        submitFunction={handleSubmit}
        backVisible={enteredPin.length > 0}
        backDisabled={enteredPin.length === 0}
        backFunction={handleBackspace}
        containerStyles={{ width: '240px' }}
      />
      
      <div style={{
        marginTop: '12px',
        textAlign: 'center',
        fontSize: '11px',
        color: '#718096',
        fontWeight: '500'
      }}>
        Enter 4-digit PIN
      </div>
    </div>
  )
}
